import React from 'react';

const NoProductsMatchFilters = ({ clearAllFilters }: { clearAllFilters: () => void }) => {
  return (
    <div
      id="no-products-match-filters"
      className="no-products-match-filters d-flex flex-column align-items-center fw-grid__wrapper"
    >
      <h4 className="no-results-title h4">Sorry, we couldn't find a match</h4>
      <p className="no-results-subtitle">Try adjusting your filters or start over.</p>
      <button onClick={clearAllFilters} className="clear-filters-pill-button btn-primary">
        Clear Filters
      </button>
      <p className="contact-us-link">
        Need help? <a href="/pages/contact-us">Contact us</a>
      </p>
    </div>
  );
};

export default NoProductsMatchFilters;
